<template>
  <detail
    :onManager="onManager"
    :data="data"
    :base-info="baseInfo"
    :extraInfo="extraInfo"
    :hiddenKeys="['external_id', 'project_domain', 'tenant', 'status']" />
</template>

<script>
import {
  getCloudEnvTableColumn,
  getEnableDateTableColumn,
  getBrandTableColumn,
  getAccountTableColumn,
  getCloudProividerTableColumn,
  getRatioTableColumn,
  getProjectDomainTableColumn,
  getCurrencyAppliedTableColumn,
  getUserRulesColumn,
  getRuleTypeColumn,
} from '../utils/columns'

export default {
  name: 'CostconversionDetail',
  props: {
    data: {
      type: Object,
      required: true,
    },
    onManager: {
      type: Function,
      required: true,
    },
  },
  data () {
    return {
      baseInfo: [
        getProjectDomainTableColumn(),
        getEnableDateTableColumn(),
        getCloudEnvTableColumn(),
        getBrandTableColumn(),
        getAccountTableColumn(),
        getCloudProividerTableColumn(),
        getRatioTableColumn(),
        getRuleTypeColumn(),
        getCurrencyAppliedTableColumn(),
      ],
    }
  },
  computed: {
    extraInfo () {
      const ret = []
      if (this.data.type === 'resource') {
        ret.push(getUserRulesColumn())
      }
      return ret
    },
  },
  methods: {
  },
}
</script>
